/**
 * EE API Keys 前端服務（呼叫 /api/ee/api_keys/*）
 */
import axios from '../api/axios';

const BASE = '/api/ee/api_keys';

export interface ApiKey {
  id: number;
  key_name: string;
  key_prefix: string;
  api_role: number[];
  is_active: boolean;
  description: string | null;
  issued_at: string;
  expires_at: string | null;
  last_used_at: string | null;
  last_used_ip: string | null;
  use_count: number;
  revoked_at: string | null;
  revoked_by: number | null;
  revoked_reason: string | null;
  edit_by: number;
  created_at: string;
  updated_at: string;
}

export interface ApiKeyCreate {
  key_name: string;
  api_role: number[];
  description?: string | null;
  expires_days?: number | null;
  expires_at?: string | null;
}

export interface ApiKeyUpdate {
  key_name?: string;
  api_role?: number[];
  description?: string | null;
  is_active?: boolean;
  expires_at?: string | null;
}

export interface ApiKeyIssueResponse {
  api_key: ApiKey;
  plaintext_key: string;
}

export interface ApiKeyRotateResponse {
  old_api_key: ApiKey;
  new_api_key: ApiKey;
  plaintext_key: string;
}

export interface ApiKeyAudit {
  id: number;
  api_key_id: number | null;
  key_prefix: string;
  api_func_code: string;
  method: string;
  path: string;
  status_code: number;
  started_at: string;
  duration_ms: number | null;
  client_ip: string | null;
  user_agent: string | null;
  request_size: number | null;
  response_size: number | null;
  error_code: string | null;
  error_message: string | null;
}

export interface PaginatedAuditList {
  items: ApiKeyAudit[];
  total: number;
  offset: number;
  limit: number;
}

export const listApiKeys = async (params?: {
  is_active?: boolean;
  api_role_id?: number;
  search?: string;
}): Promise<ApiKey[]> => {
  const res = await axios.get(`${BASE}/`, { params });
  return res.data;
};

export const getApiKey = async (id: number): Promise<ApiKey> => {
  const res = await axios.get(`${BASE}/${id}`);
  return res.data;
};

export const issueApiKey = async (payload: ApiKeyCreate): Promise<ApiKeyIssueResponse> => {
  const res = await axios.post(`${BASE}/`, payload);
  return res.data;
};

export const updateApiKey = async (id: number, payload: ApiKeyUpdate): Promise<ApiKey> => {
  const res = await axios.put(`${BASE}/${id}`, payload);
  return res.data;
};

export const revokeApiKey = async (id: number, reason?: string | null): Promise<ApiKey> => {
  const res = await axios.post(`${BASE}/${id}/revoke`, { reason });
  return res.data;
};

export const rotateApiKey = async (
  id: number,
  reason?: string | null,
): Promise<ApiKeyRotateResponse> => {
  const res = await axios.post(`${BASE}/${id}/rotate`, { reason });
  return res.data;
};

export const listKeyAudit = async (
  id: number,
  params?: { offset?: number; limit?: number },
): Promise<PaginatedAuditList> => {
  const res = await axios.get(`${BASE}/${id}/audit`, { params });
  return res.data;
};

export const listAllAudit = async (params?: {
  offset?: number;
  limit?: number;
  api_key_id?: number;
  func_code?: string;
  status_code?: number;
  since?: string;
  until?: string;
}): Promise<PaginatedAuditList> => {
  const res = await axios.get(`${BASE}/audit`, { params });
  return res.data;
};
